class MultistepWizard extends HTMLElement {
  constructor() {
    super()
    this.path = []
    this.respuestas = []
    this.layoutBlock = this.closest('[data-layout]')
    this.form = this.querySelector('form')
    this.results = this.querySelector('multistep-results')
    this.ajaxSuccessCallback = undefined
  }

  connectedCallback() {
    document.addEventListener('turbo:load', () => {
      this.showStep(this.getInitialStep())
      this.checkCrossOrigin()
      this.frameElement = this.crossorigin ? false : window.frameElement
      this.setBeforeSend()

      if (this.crossorigin || this.frameElement) {
        this.layoutBlock.classList.add('iframed')
        this.frameAutoheight()
      }

      if (this.layoutBlock.dataset.layout === 'none') {
        this.layoutBlock.classList.add('landing-layout-page-wizard')
      }
      else if (this.layoutBlock.dataset.layout === 'application') {
        this.layoutBlock.classList.add('full-layout-page-wizard')
      }
    })

    this.form.addEventListener('submit', () => {
      document.body.dataset.loading = 'Procesando'
      window.scrollTo(0, 0)
      this.frameAutoheight()
    })

    this.form.addEventListener('ajax:success', event => {
      this.results.innerHTML = event.detail[0]
      delete document.body.dataset.loading
      window.scrollTo(0, 0)
      this.frameAutoheight()
      if (typeof this.ajaxSuccessCallback === 'function') {
        this.ajaxSuccessCallback()
      }
      this.nofitySuccessToGA()
    })

    this.addEventListener('next', function (event) {
      const stepOrigin = event.target

      stepOrigin.hide()
      this.path.push(stepOrigin.position)
      if (stepOrigin.position === 'start') {
        this.respuestas.push('start')
      } else {
        this.respuestas.push(stepOrigin.answers.value)
      }

      if (stepOrigin.getAttribute('go') === 'end') {
        this.path.push('end')
        this.respuestas.push('end')
        this.form.commit.click()
        location.hash = 'end'
      } else {
        const nextStep = this.findStep(stepOrigin.next)
        nextStep.prev = stepOrigin.position
        this.showStep(nextStep)
      }
    })

    this.addEventListener('prev', function (event) {
      const stepOrigin = event.target
      stepOrigin.hide()
      const prevStep = this.findStep(stepOrigin.prev)
      this.showStep(prevStep)
      this.path.pop()
      this.respuestas.pop()
    })

    document.addEventListener('turbo:render', () => {
      this.frameAutoheight()
    })
  }


  nofitySuccessToGA() {
    try {
      dataLayer.push({
        event: 'GAEvent',
        eventCategory: 'captadores',
        eventAction: 'captador_completed',
        eventLabel: `${this.dataset.captador}_${location.href}`,
        eventValue: 0
      })
    } catch (exc) {
      throw exc.message
    }
  }

  get omitingStart() {
    return (new URLSearchParams(location.search)).has('omit_start')
  }

  showStep(stepElem) {
    if (stepElem) {
      location.hash = stepElem.getAttribute('position')
      stepElem.show()
    }
  }

  checkCrossOrigin() {
    try {
      this.crossorigin = Object(window.parent.location).keys || false
    } catch (ex) {
      this.crossorigin = true
    }
  }

  frameAutoheight() {
    let evHandlers = {
      onChange: () => {
        const timer = setTimeout(() => {
          this.frameElement.height = this.offsetHeight
          window.clearTimeout(timer)
        }, 500)
      },
      onRetry: () => {
        let windowOffset = window.parent.pageYOffset
        let frameTop = this.frameElement.getBoundingClientRect().top
        window.parent.scrollTo(0, windowOffset + frameTop)
      }
    }

    if (this.frameElement) {
      evHandlers.onChange()
    } else {
      let postHeight = () => {
        window.parent.postMessage('rankia-height-' + this.offsetHeight, '*')
      }
      postHeight()

      evHandlers = {
        onChange: () => {
          const timer = setTimeout(() => {
            postHeight()
            window.clearTimeout(timer)
          }, 500)
        },
        onRetry: () => {
          window.parent.postMessage('rankia-retry', '*')
        }
      }
    }

    this.addEventListener('show', evHandlers.onChange)
    document.addEventListener('turbo:load', evHandlers.onChange)
  }

  setBeforeSend() {
    this.form.addEventListener('ajax:before', () => {
      if (this.form.checkValidity()) {
        this.form.path.value = this.path.reverse().join()
      } else {
        alert('Campos requeridos pendientes')
      }
    })
  }

  findStep(position) {
    return this.querySelector(`multistep-step[position="${position}"]`)
  }

  getInitialStep() {
    const initialSteps = [
      'start',
      'tipo',
      'importe_inversion',
      'nivel'
    ]

    return initialSteps
      .map(step => this.findStep(step))
      .find(step => step !== null)
  }
}

export default MultistepWizard
